import { ApolloError } from "@apollo/client";
import { MenuItem, Select, Typography } from "@mui/material";
import { useAlerts } from "components/Alerts/AlertProvider";
import { Dialog } from "components/Dialog";
import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";
import { useCreateInitial } from "hooks/useCreateReport";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export const InitialReportDialog = ({
  facilityId,
  onClose,
}: {
  facilityId: string;
  onClose: () => void;
}) => {
  const [createInitial, { loading }] = useCreateInitial();
  const navigate = useNavigate();
  const alerts = useAlerts();

  const yearOptions = useMemo(() => {
    const currentCalendarYear = new Date().getFullYear();
    return [...new Set([currentTierIIReportingYear, currentCalendarYear])];
  }, []);

  const [reportingYear, setReportingYear] = useState(currentTierIIReportingYear);

  const onSelect = () => {
    createInitial({
      variables: {
        facilityId,
        reportingYear,
      },
      onCompleted(data) {
        navigate(data.createTierIIReport.id);
        onClose();
      },
      onError(err: ApolloError) {
        const reportAlreadyExistsError = err.graphQLErrors.find(
          (e) => e.extensions?.code === "REPORT_FOR_YEAR_ALREADY_EXISTS"
        );
        if (reportAlreadyExistsError) {
          alerts.error(err.message);
        } else {
          alerts.error("Error creating initial notification report");
        }
        console.error("Error creating initial notification report", err);
        onClose();
      },
    });
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title="Select Reporting Year"
      primaryActionButtonProps={{
        loading,
        onClick: onSelect,
        saveText: "Select",
        startIcon: null,
      }}
    >
      <Typography>Select the reporting year for the initial report.</Typography>
      <Select value={reportingYear} onChange={(e) => setReportingYear(Number(e.target.value))}>
        {yearOptions.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </Dialog>
  );
};
